import { INTERVIEW_LINK_PREVIEW } from "./constants";

interface AiInterviewSmsPreviewProps {
  message: string;
}

// The link stub is shown appended, never inside the message: the backend appends the
// freshly-minted vendor URL, so it can't be edited to a stale/wrong one.
export function AiInterviewSmsPreview({ message }: Readonly<AiInterviewSmsPreviewProps>) {
  return (
    <div>
      <p className="mb-1 text-extraSmall text-medium-gray">SMS preview · link always auto-appended</p>
      <div className="max-w-[85%] rounded-[0.9rem_0.9rem_0.9rem_0.25rem] bg-light-gray px-3 py-2 text-small leading-[1.45] text-black">
        {message} <span className="text-gray underline">{INTERVIEW_LINK_PREVIEW}</span>
      </div>
    </div>
  );
}
